export default "__VITE_ASSET__CJUZSwzz__"